import { render, staticRenderFns } from "./KontaktIcon.vue?vue&type=template&id=eb990c96"
import script from "./KontaktIcon.vue?vue&type=script&lang=js"
export * from "./KontaktIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports